import { ADMISSION, AdmissionRoutes } from 'constants/routes';

import { BASE_API_URL } from './index';

export const permissionsEndpoint = `${BASE_API_URL}/${ADMISSION}/${AdmissionRoutes.PERMISSIONS}/`;
